import AppRouter from 'AppRouter'
import Header from 'common/Header'

export default function App() {
	return <>
		<Header />
		<AppRouter />
	</>
}
